module.exports = __webpack_public_path__ + "assets/img/zasadnicza.f557df40.png";